import React from 'react';
import { connect } from 'react-redux';

import Image from 'components/atoms/Image';
import { RootState } from 'types';
import { translate } from 'utils/translate';
import { withRouter } from 'utils/withRouter';

interface ApplicationErrorProps {
    applicationError: boolean;
}

interface ApplicationErrorState {
    applicationError: boolean;
}

class ApplicationError extends React.Component<ApplicationErrorProps, ApplicationErrorState> {
    constructor(props: ApplicationErrorProps) {
        super(props);
        this.state = {
            applicationError: false,
        };
    }

    static getDerivedStateFromProps(props: ApplicationErrorProps, state: ApplicationErrorState) {
        if (props.applicationError !== state.applicationError) {
            return {
                applicationError: props.applicationError,
            };
        }

        return null;
    }

    render() {
        return (
            <>
                {this.state.applicationError && (
                    <section className="z-100 fixed left-0 top-0 items-center justify-center inset-0 flex fixed-position w-full h-full   bg-white overflow-hidden">
                        <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="relative">
                                <Image src="/static/images/application-error.png" className="mx-auto" alt="error" />
                                <blockquote className="mt-8">
                                    <div className="max-w-3xl mx-auto text-center leading-9 font-sm text-gray-900">
                                        <p className="font-sm font-bold">{translate('System Error')}</p>
                                        <p className="text-sm">
                                            {translate('Application error please contact the system administrator')}
                                        </p>
                                    </div>
                                </blockquote>
                            </div>
                        </div>
                    </section>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    applicationError: state.errors.applicationError,
});

export default connect(mapStateToProps)(withRouter(ApplicationError));
